import React, { useRef } from 'react'
import Icons from '~/Common-Objects/UI/Icons/index'
import HelpPopup from '~/pages/cp/automation/addNew/helpPopup/helpPopup'

// Group component
const Group = ({ title, children, style, className }) => {
  let classes = "automationStepsRoot";
  if (className) {
    classes += " " + className;
  }
  return (
    <div className={classes} style={style}>
      <h3 className="automationStepsTitle">{title}</h3>
      <ul className="automationStepsGroupList">{children}</ul>
    </div>
  )
}

// Step component
const Step = ({
  onClick,
  style = {},
  alt,
  disabled,
  icon,
  title,
  subTitle,
  helpType,
  ctaIcon = <Icons icon='chevronRight' color='currentColor' />,
  ctaWidth = "20px",
  iconHolderStyle = {},
  clickable = true,
  hoverable = true,
  postHogTag
}) => {

  let automationStepsStepClasses = "automationStepsStep";
  if (!clickable) {
    automationStepsStepClasses += " automationStepsStepNoClick";
  }
  if (hoverable) {
    automationStepsStepClasses += " automationStepsStepHoverable";
  }

  return (
    <>
      <li>
        <button className={automationStepsStepClasses} onClick={onClick} style={style} title={alt} disabled={disabled} data-ph={postHogTag}>
          <div className="automationStepsStepIcon" style={iconHolderStyle}>{icon}</div>
          <div className="automationStepsStepDetails">
            <div className="automationStepsStepTitle">{title}</div>
            <div className="automationStepsStepDescription">{subTitle}</div>
          </div>
          {!!helpType && <HelpPopup type={helpType} />}
          <div className="automationStepsStepIndicator" style={{ width: ctaWidth }}>
            {ctaIcon}
          </div>
        </button>
      </li>
    </>
  )
}

// Export compound component
const AutomationSteps = {
  Group,
  Step
}

export default AutomationSteps
